import { render, staticRenderFns } from "./ProntuarioPreNatal.vue?vue&type=template&id=1944b033&"
import script from "./ProntuarioPreNatal.vue?vue&type=script&lang=js&"
export * from "./ProntuarioPreNatal.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioPreNatal.vue?vue&type=style&index=0&id=1944b033&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports